import { IonPage } from '@ionic/react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useGetUnitActivationById } from '@apps-common/apis/portal/unit-activations'
import {
  UnitActivationDetailsCard,
  UnitActivationDetailsOptions
} from '@apps-common/apps/portal/pages/units/pages/activations/pages/activation-details/components'
import { PullRefresh } from '@apps-common/components/common'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { Header, LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar, NavbarIcon } from '@apps-common/components/navigation'
import { UNIT_ACTIVATION_UPDATE_LISTENER_STATUSES } from '@apps-common/config/unit-activation'
import { useUnitActivationContext } from '@apps-common/contexts'
import { usePortalUnitsFilterStore } from '@apps-common/stores'
import { ROUTE_UNIT_ACTIVATION_DETAILS } from '@apps-radionet-portal-root/src/config/private-routes'

export const UnitActivationDetailsPage: React.FC = () => {
  const { open, setOpen } = usePortalUnitsFilterStore()
  const { activationId } = useParams<{ activationId: string }>()

  const id = parseInt(activationId, 10)

  const { isLoading, isError, isRefetching, data, refetch } = useGetUnitActivationById({
    config: {
      enabled: id > 0
    },
    id
  })
  const activationContext = useUnitActivationContext()

  const icons: any[] = [<NavbarIcon icon='settings' callback={() => setOpen(!open)} />]

  const loading = isLoading || isError

  useEffect(() => {
    if (!activationContext || !data || !UNIT_ACTIVATION_UPDATE_LISTENER_STATUSES.includes(data.status)) {
      return
    }

    activationContext.subscribe({
      request: data,
      callback: () => refetch(),
      refresh: () => refetch()
    })

    return () => activationContext.unsubscribe(data.unitActivationRequestId)
  }, [activationContext, data, refetch])

  return (
    <IonPage>
      <Header>
        <Navbar showBack transparent icons={icons} />
        <Breadcrumbs route={ROUTE_UNIT_ACTIVATION_DETAILS} />
        <div className='flex items-center justify-between'>
          <PageTitle>Device Activation</PageTitle>
          <UnitActivationDetailsOptions activation={data} displayMode='mobile' />
        </div>
      </Header>
      <LayoutContainer>
        <LayoutPadding>
          <PullRefresh loading={loading} callback={refetch} />
          <div className='max-w-[1000px]'>
            <UnitActivationDetailsCard loading={loading} activation={data} />
          </div>
        </LayoutPadding>
      </LayoutContainer>
    </IonPage>
  )
}
